import React, { useState } from 'react';
import { Button } from '@/components/atoms/NewPcButton';
import { Dialog, DialogContent, DialogClose, DialogTrigger } from '@/components/atoms/Dialog';
import { MonitoringGoodsDetail } from '@/types/api';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useToast } from '@/hooks/V3/useToast';
import { useAppSelector } from '@/redux/store';
import { cp } from 'fs';
import RegisteredMonitoringEdit from './RegisteredMonitoringEdit';

const MAX_KEYWORDS = 10;

const EditKeyword = ({
  goods,
  isMockGoods,
}: {
  goods: MonitoringGoodsDetail;
  isMockGoods: boolean;
}) => {
  const user = useAppSelector((state) => state.user);
  const allKeywords = goods.RelatedKeyword || [];
  // 실제 서버 데이터에 맞게 초기값 세팅
  const [selectedKeywords, setSelectedKeywords] = useState<string[]>([...allKeywords.slice(0, 4)]);
  const [input, setInput] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const { showToast } = useToast();

  // 키워드 변경 mutation (API 엔드포인트/파라미터는 실제 명세에 맞게)
  const { mutate: updateKeywords, isPending: isUpdating } = usePost(
    CPLAT_API_ROUTES.setUserMonitoringGoods,
  );

  // 키워드 추가
  const handleAdd = () => {
    const trimmed = input.trim();
    if (trimmed && !selectedKeywords.includes(trimmed) && selectedKeywords.length < MAX_KEYWORDS) {
      setSelectedKeywords([...selectedKeywords, trimmed]);
      setInput('');
    }
  };

  // 키워드 삭제
  const handleRemove = (kw: string) => {
    setSelectedKeywords(selectedKeywords.filter((k) => k !== kw));
  };

  // 후보 키워드 토글
  const handleToggle = (kw: string) => {
    if (selectedKeywords.includes(kw)) {
      handleRemove(kw);
    } else if (selectedKeywords.length < MAX_KEYWORDS) {
      setSelectedKeywords([...selectedKeywords, kw]);
    }
  };

  // 키워드 변경하기 버튼 클릭
  const handleChangeKeywords = () => {
    updateKeywords(
      {
        cplatToken: user.CplatToken,
        StoreName: goods.StoreName,
        GoodsNo: goods.GoodsNo,
        GoodsImageUrl: goods.GoodsImageUrl,
        GoodsName: goods.GoodsName,
        CategoryFullName: goods.CategoryFullName,
        UseYn: 'Y',
        RelatedKeywordList: selectedKeywords,
        GoodsUrl: goods.GoodsUrl,
        GoodsPrice: goods.GoodsPrice,
        relatedKeywordRankInfo: {}, // 셀러박스에서는 변화량 데이터 빈 객체로 전달, 1일 이후 자동 수집
        ShippingFee: goods.ShippingFee,
        GoodsRegisterDate: goods.GoodsRegisterDate,
        NoticeYn: 'N',
        IsMyStoreGoods: goods.IsMyStoreGoods,
        MallSeq: goods.MallSeq,
        InsertYn: 'Y',
      },
      {
        onSuccess: () => {
          showToast('success', '키워드가 변경되었습니다!');
          setDialogOpen(false);
        },
        onError: () => {
          showToast('warning', '키워드 변경에 실패했습니다.');
        },
      },
    );
  };

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <div className="flex flex-col items-end gap-2">
        <DialogTrigger asChild>
          <Button
            onClick={(e) => e.stopPropagation()}
            variant="secondary"
            className="h-fit px-[10px] py-[6px] Body5M14"
          >
            키워드 관리
          </Button>
        </DialogTrigger>
        <RegisteredMonitoringEdit
          goods={goods}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          isMockGoods={isMockGoods}
        />
      </div>
    </Dialog>
  );
};

export default EditKeyword;
